VLW.HomePIXIDisplacement = class extends VLW.classBase {
	constructor() {
		VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HOME      = 1;
		VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HOMMES    = 4;
		VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_TERROIR   = 3;
		VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HERITAGE  = 2;
		VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HERITAGE2 = 5;
		VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_NOSVINS   = 6;
		VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_MENTIONS  = 7;
		VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_NOSVIGNOBLES  = 8;
		super();
		this.align              = "";
		this.mainContainer      = new PIXI.Container();
		this.mainContainer.name = "displacementMainContainer";
		this.cpt                = 0;
	}
	
	set resources(resources) {
		this._resources  = resources;
		this.spriteImage = new PIXI.Sprite(this._resources.image.texture);
		this.spriteImage.size = this.mainContainer.size = {width: this.spriteImage.width, height: this.spriteImage.height};
		this.mainContainer.addChild(this.spriteImage);
		this.setFX();
	}
	
	render() {
		return;
		switch (true) {
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_NOSVINS:
				if (this.displacementFilter) {
					this.displacementFilter.scale.xTo = -30 * window.mousePosition.rationMiddle.x;
					this.displacementFilter.scale.yTo = -45 * window.mousePosition.rationMiddle.y;
					this.displacementFilter.scale.x   = this.displacementFilter.scale.x + (this.displacementFilter.scale.xTo - this.displacementFilter.scale.x) * 0.1;
					this.displacementFilter.scale.y   = this.displacementFilter.scale.y + (this.displacementFilter.scale.yTo - this.displacementFilter.scale.y) * 0.1;
				}
				break;
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HERITAGE2:
				if (this.displacementFilter) {
					this.displacementFilter.scale.xTo = 15 * window.mousePosition.rationMiddle.x;
					this.displacementFilter.scale.yTo = 9 * window.mousePosition.rationMiddle.y;
					this.displacementFilter.scale.x   = this.displacementFilter.scale.x + (this.displacementFilter.scale.xTo - this.displacementFilter.scale.x) * 0.1;
					this.displacementFilter.scale.y   = this.displacementFilter.scale.y + (this.displacementFilter.scale.yTo - this.displacementFilter.scale.y) * 0.1;
				}
				break;
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HOMMES:
				if (this.displacementFilter) {
					this.displacementFilter.scale.xTo = 40 * window.mousePosition.rationMiddle.x;
					this.displacementFilter.scale.yTo = 45 * window.mousePosition.rationMiddle.y;
					this.displacementFilter.scale.x   = this.displacementFilter.scale.x + (this.displacementFilter.scale.xTo - this.displacementFilter.scale.x) * 0.1;
					this.displacementFilter.scale.y   = this.displacementFilter.scale.y + (this.displacementFilter.scale.yTo - this.displacementFilter.scale.y) * 0.1;
				}
				break;
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_MENTIONS:
				if (this.displacementFilter) {
					this.displacementFilter.scale.xTo = 15 * window.mousePosition.rationMiddle.x;
					this.displacementFilter.scale.yTo = 20 * window.mousePosition.rationMiddle.y;
					this.displacementFilter.scale.x   = this.displacementFilter.scale.x + (this.displacementFilter.scale.xTo - this.displacementFilter.scale.x) * 0.1;
					this.displacementFilter.scale.y   = this.displacementFilter.scale.y + (this.displacementFilter.scale.yTo - this.displacementFilter.scale.y) * 0.1;
				}
				break;
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_TERROIR:
				this.spriteDisplacement && (this.spriteDisplacement.position.x = Math.sin(this.cpt * .005) * 100);
				this.spriteDisplacement && (this.spriteDisplacement.position.y = Math.cos(this.cpt * .005) * 100);
				this.spriteDisplacement && this.spriteDisplacement.scale.set(1);
				break;
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HERITAGE:
				this.spriteDisplacement && (this.spriteDisplacement.position.x = Math.sin(this.cpt * .01) * 170);
				this.spriteDisplacement && (this.spriteDisplacement.position.y = Math.cos(this.cpt * .01) * 170);
				break;
			case this.displacementType ===	VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_NOSVIGNOBLES:
				var _deltx =  (this.cpt * .2);
				this.spriteDisplacement && this.spriteDisplacement.scale.set(10, 10);
				this.spriteDisplacement && this.spriteDisplacement.position.set(windowSize.width*.5+_deltx*6,windowSize.height*.5+_deltx*4);
				this.containerFX && (this.containerFX.alpha = 1);
				break;
			default:
				var _deltx =  (this.cpt * .05);
				this.spriteDisplacement && this.spriteDisplacement.scale.set(4, 2);
				this.spriteDisplacement && this.spriteDisplacement.position.set(windowSize.width*.5+_deltx*6,windowSize.height*.5+_deltx*4);
				this.containerFX && (this.containerFX.alpha = .8);
				break;		}
		this.cpt++;
	}
	
	size() {
		this.setFullScreen(this.spriteImage);
		this.spriteImageFX 	&& this.setFullScreen(this.spriteImageFX);
		this.spriteMask 	&& this.setFullScreen(this.spriteMask);
		//this.spriteDisplacement && this.spriteDisplacement.position.set(windowSize.width * .5, windowSize.height * .5);
		
		this.align === "tl" && this.mainContainer.position.set(0, 0);
		this.align === "rb" && this.mainContainer.position.set((this.mainContainer.width - windowSize.width) * -1, (this.mainContainer.height - windowSize.height) * -1);
		this.align === "cc" && this.mainContainer.position.set((windowSize.width - this.mainContainer.width) * .5, (windowSize.height - this.mainContainer.height) * .5);
		if ([
			VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_MENTIONS,
			VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HOMMES,
			VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HERITAGE2,
			VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_NOSVINS
		].includes(this.displacementType)) {
			this.spriteDisplacement&& this.spriteDisplacement.position.set(this.mainContainer.x, this.mainContainer.y);
			this.spriteDisplacement&& (this.spriteDisplacement.width = this.spriteImage.width);
			this.spriteDisplacement&& (this.spriteDisplacement.height= this.spriteImage.height);
		}
		if(this.spriteImageFX && VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HOME===this.displacementType){
			this.spriteImageFX.scale.set(this.spriteImageFX.scale.x-0.01);
		}
		if(this.spriteImageFX && VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_NOSVIGNOBLES===this.displacementType){
			this.spriteImageFX.scale.set(this.spriteImageFX.scale.x-0);
		}
	}
	
	
	setFullScreen(...aElt) {
		aElt.forEach(elt => {
			let ratio  = Math.max(windowSize.width / elt.size.width, windowSize.height / elt.size.height);
			elt.width  = Math.round(elt.size.width * ratio);
			elt.height = Math.round(elt.size.height * ratio);
		});
	}
	
	setFX_LesHommes() {
		this.spriteDisplacement      = new PIXI.Sprite(this._resources.displacement.texture);
		this.spriteDisplacement.size = {width: this.spriteImage.width, height: this.spriteImage.height};
		this.setFullScreen(this.spriteDisplacement);
		switch (true) {
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_MENTIONS:
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HOMMES:
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HERITAGE2:
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_NOSVINS:
				this.spriteDisplacement.position.set(0, 0);
				break;
			default:
				this.spriteDisplacement.anchor.set(0.5);
				this.spriteDisplacement.position.set((windowSize.width) * .5, (windowSize.height) * .5);
				break;
		}
		this.spriteDisplacement.positionOr = {x: this.spriteDisplacement.position.x, y: this.spriteDisplacement.position.y};
		this.spriteDisplacement.scaleOr    = {x: this.spriteDisplacement.scale.x, y: this.spriteDisplacement.scale.y};
		this.displacementFilter            = new PIXI.filters.DisplacementFilter(this.spriteDisplacement);
		this.spriteImage.filters           = [this.displacementFilter];
		PIXIAPP.addChild(this.spriteDisplacement,9999999);
		// this.spriteDisplacement.alpha=.5;
	}
	
	setFX() {
		if (VERSION_SMARTP || !this._resources.displacement) {
			return;
		}
		if ([VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_MENTIONS,VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_NOSVINS, VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HOMMES, VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HERITAGE2].includes(this.displacementType)) {
			this.setFX_LesHommes();
			return;
		}
		
		this.containerFX             = new PIXI.Sprite();
		this.spriteDisplacement      = new PIXI.Sprite(this._resources.displacement.texture);
		this.spriteImageFX           = new PIXI.Sprite(this._resources.image.texture);
		this.spriteImageFX.size      = {width: this.spriteImage.width, height: this.spriteImage.height};
		this.spriteDisplacement.size = {width: this.spriteImage.width, height: this.spriteImage.height};
		switch (true) {
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_TERROIR:
				this.spriteDisplacement.scale.set(1);
				break;
			case this.displacementType === VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HERITAGE:
				this.spriteDisplacement.scale.set(4);
				break;
			default:
				this.spriteDisplacement.anchor.set(.5);
				this.spriteDisplacement.position.set((windowSize.width) * .5, (windowSize.height) * .5);
				this.spriteDisplacement.scale.set(.25);
				break;
		}
		this.containerFX.addChild(this.spriteImageFX);
		//this.spriteDisplacement.anchor.set(.5);
		this.spriteDisplacement.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.MIRRORED_REPEAT;
		this.displacementFilter                              = new PIXI.filters.DisplacementFilter(this.spriteDisplacement);
		this.spriteImageFX.filters                           = [this.displacementFilter];
		this.mainContainer.addChild(this.containerFX);
		PIXIAPP.addChild(this.spriteDisplacement, 999);
		this.setFX_Mask();
	}
	
	setFX_Mask() {
		if (!this._resources.mask) {
			return;
		}
		this.spriteMask       = new PIXI.Sprite(this._resources.mask.texture);
		this.spriteMask.size  = {width: this.spriteImage.width, height: this.spriteImage.height};
		this.containerFX.mask = this.spriteMask;
		this.mainContainer.addChild(this.spriteMask);
	}
	
	instanceClean() {
		this.mainContainer.renderable = false;
		PIXIAPP.app.stage.removeChild(this.mainContainer);
		this.spriteImage 		&& this.mainContainer	.removeChild(this.spriteImage);
		this.containerFX 		&& this.mainContainer	.removeChild(this.containerFX);
		this.spriteMask 		&& this.mainContainer	.removeChild(this.spriteMask);
		this.spriteDisplacement && PIXIAPP.app.stage	.removeChild(this.spriteDisplacement);
		this.spriteImage 		&& this.spriteImage	.destroy({children: true, texture: true, baseTexture: true});
		this.spriteDisplacement && this.spriteDisplacement	.destroy({children: true, texture: true, baseTexture: true});
		this.containerFX 		&& this.containerFX	.destroy({children: true, texture: true, baseTexture: true});
		this.spriteMask 		&& this.spriteMask	.destroy({children: true, texture: true, baseTexture: true});
		this.mainContainer	.destroy({children: true, texture: true, baseTexture: true});
		
		super.instanceClean();
	}
}